"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dot_object_1 = __importDefault(require("dot-object"));
const dot = new dot_object_1.default('.', false, true, false);
function getValidationErrorsObject(validationErrors) {
    if (validationErrors.length === 0)
        return null;
    const errors = {};
    for (const validationError of validationErrors) {
        errors[validationError.key] = validationError.code;
    }
    return dot.dot(errors);
}
exports.default = getValidationErrorsObject;
